export default {
  isEmpty: (state) => {
    return state.items ? !state.items.length : true
  }
}
